module.exports = __webpack_public_path__ + "static/img/hardik.2290ea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hardik.png
// module id = AhsH
// module chunks = 1